// client/src/components/services_tester/ServicesPanel.jsx
import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Stack,
  Chip,
} from '@mui/material';
import { CloudQueue } from '@mui/icons-material';
import ServiceCard from './ServiceCard';
import { DIRECT_SERVICES } from './common/constants';

export default function ServicesPanel({
  networkDiagnostics,
  healthCheckLoading,
  isAuthenticated,
  handleServiceTest,
}) {
  const accessibleServices = isAuthenticated
    ? DIRECT_SERVICES.length
    : DIRECT_SERVICES.filter((s) => !s.requiresAuth).length;
  const totalServicesCount = DIRECT_SERVICES.length;

  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        borderRadius: 1,
      }}
    >
      <CardContent
        sx={{
          p: 0.75,
          '&:last-child': { pb: 0.75 },
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            flexShrink: 0,
            mb: 0.5,
          }}
        >
          <CloudQueue sx={{ fontSize: 16 }} />
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              fontSize: '0.75rem',
              lineHeight: 1.2,
            }}
          >
            Микросервисы
          </Typography>
          <Chip
            label={`${accessibleServices}/${totalServicesCount}`}
            size="small"
            color={isAuthenticated ? 'success' : 'warning'}
            variant="outlined"
            sx={{
              height: 16,
              fontSize: '0.55rem',
              ml: 0.5,
              '& .MuiChip-label': { px: 0.5 },
            }}
          />
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
          <Stack spacing={0.5}>
            {DIRECT_SERVICES.map((service) => (
              <ServiceCard
                key={service.key}
                service={service}
                diagnostics={networkDiagnostics[service.key] || {}}
                onTest={handleServiceTest}
                loading={healthCheckLoading}
                isAuthenticated={isAuthenticated}
              />
            ))}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
